import styled from 'styled-components'

import { Button, DataTable } from '@/components'
import { FlexWrapper } from '@/components/layout/flex/flexWrapper'
import { useAxios } from '@/context/axiosContext'
import { NoDataComponent } from '@/pages/bizMgmt/bizMgmt'
import { tableStyles } from '@/styles/dataTable/style'
import commonUtils from '@/utils/commonUtils'
import React, { useEffect, useState } from 'react'
import { TableColumn } from 'react-data-table-component'
import { useLocation, useNavigate } from 'react-router-dom'
import { useRedis } from '@/hooks/useRedis'

interface GetRequest {
  bizCd?: string //업체코드
}

export interface DataRow {
  cmpnyCd: string
  bizCd: string
  seq: number
  chngDt: string
  bizNm: string
  bizGubn: string
  ntnCd: string
  areaCd: string
  baseDomain: string
  chrgeDomain: string
  addr: string
  phone: string
  email: string
  useYn: string
  mshipYn: string
  batchYn: string
  manualYn: string
  userName: string
  uri: string
  rem: string
  schrTag: string
  etc1: string
  etc2: string
  etc3: string
  etc4: string
  etc5: string
  regId: string
  updId: string
  regDate: string
  updDate: string
  rnum: string
  newBatchYn: string
}

const BizHist: React.FC = () => {
  const { getComCodeValue } = useRedis()
  const axios = useAxios()
  const navigate = useNavigate()
  const location = useLocation()
  const [data, setData] = useState<DataRow[]>([])
  const [requestData] = useState({
    bizCd: String(location.state?.bizCd),
  })

  const handleDetailClick = (bizCd: string, seq: number) => {
    window.scrollTo(0, 0)
    navigate('/bizMgmt/detailHist', {
      state: {
        bizCd: bizCd,
        seq: seq,
      },
    })
  }

  const columns: TableColumn<DataRow>[] = [
    {
      name: 'No.',
      selector: (row) => parseInt(row.rnum, 10),
      sortable: true,
      center: true,
      minWidth: '40px',
      maxWidth: '60px',
    },
    {
      name: '업체코드',
      selector: (row) => row.bizCd,
      sortable: true,
      center: true,
    },
    {
      name: '업체명',
      selector: (row) => row.bizNm,
      sortable: true,
      wrap: true,
      grow: 1,
    },
    {
      name: '사용여부',
      selector: (row) => getComCodeValue('USE_YN', row.useYn)?.codeNm || '',
      sortable: true,
      center: true,
      minWidth: '80px',
      maxWidth: '80px',
    },
    {
      name: '회원제여부',
      selector: (row) => getComCodeValue('MSHIP_YN', row.mshipYn)?.codeNm || '',
      sortable: true,
      center: true,
      minWidth: '100px',
      maxWidth: '100px',
    },
    // {
    //   name: '배치여부',
    //   selector: (row) => getComCodeValue('BATCH_YN', row.batchYn)?.codeNm || '',
    //   sortable: true,
    //   center: true,
    //   minWidth: '80px',
    //   maxWidth: '80px',
    // },
    {
      name: '배치여부',
      selector: (row) =>
        getComCodeValue('NEW_BATCH_YN', row.newBatchYn)?.codeNm || '',
      sortable: true,
      center: true,
      minWidth: '110px',
      maxWidth: '110px',
    },
    {
      name: '수기관리여부',
      selector: (row) =>
        getComCodeValue('MANUAL_YN', row.manualYn)?.codeNm || '',
      sortable: true,
      center: true,
      minWidth: '110px',
      maxWidth: '110px',
    },
    {
      name: '비고',
      selector: (row) => row.rem,
      sortable: true,
      wrap: true,
      grow: 1,
    },
    {
      name: '수정자',
      selector: (row) => row.userName,
      sortable: true,
      center: true,
    },
    {
      name: '수정일시',
      selector: (row) => row.updDate,
      format: (row) => commonUtils.formatDate(row.updDate),
      sortable: true,
      center: true,
    },
    {
      name: '',
      cell: (row) => (
        <FlexWrapper gap="20px">
          <Button
            variant="outlined"
            color="neverbe"
            size="xs"
            onClick={() => handleDetailClick(row.bizCd, row.seq)}
          >
            상세
          </Button>
        </FlexWrapper>
      ),
      minWidth: '300px',
      sortable: false,
    },
  ]

  useEffect(() => {
    getBizHistList()
  }, [])

  const getBizHistList = async () => {
    try {
      const data: GetRequest = {
        bizCd: requestData.bizCd,
      }

      const response = await axios.get('/bizMgmt/listHist', {
        params: { ...data },
      })

      const listData = response.data

      if (Array.isArray(listData)) {
        setData(listData)
      }
    } catch (err: any) {
      console.error('Error fetching getBizHistList:', err)
    }
  }

  return (
    <>
      <div style={{ width: '100%', height: '100%', marginTop: '50px' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            marginBottom: '10px',
            alignItems: 'center',
            marginTop: '50px',
          }}
        >
          <p style={{ marginLeft: '20px', fontSize: '20px' }}>업체이력</p>
        </div>
      </div>
      <BizHistContainerWrapper>
        <DataTable
          columns={columns}
          data={data}
          customStyles={tableStyles}
          noDataComponent={<NoDataComponent />}
        />
      </BizHistContainerWrapper>
    </>
  )
}

const BizHistContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 480px;
`

export default BizHist
